import Cookies from 'universal-cookie';

export const getJwtFromReq = (req) => {
  const cookies = new Cookies(req?.headers.cookie || '');
  const token = cookies.get('ac_token');

  return token;
}